import { useKeyboardIsOpen } from '@akin-home/utils/native';
import { useEffect } from 'react';
import {
  Easing,
  useAnimatedScrollHandler,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';

export const useFloatingActionControl = () => {
  const lastContentOffset = useSharedValue(0);
  const isScrolling = useSharedValue(false);
  const hide_buttons = useSharedValue(false);

  const open = useKeyboardIsOpen();

  const floating_action_styles = useAnimatedStyle(() => {
    return {
      bottom: withTiming(hide_buttons.value ? -60 : 30, {
        duration: 400,
        easing: Easing.inOut(Easing.ease),
      }),
    };
  });

  const scrollHandler = useAnimatedScrollHandler({
    onScroll: (event) => {
      const isCloseToBottom = () => {
        const paddingToBottom = 10;
        return (
          event.layoutMeasurement.height + event.contentOffset.y >=
          event.contentSize.height - paddingToBottom
        );
      };

      if (
        lastContentOffset.value > event.contentOffset.y &&
        isScrolling.value
      ) {
        // Scrolled Up
        hide_buttons.value = false;
      } else if (isCloseToBottom()) {
        hide_buttons.value = false;
      } else if (
        lastContentOffset.value < event.contentOffset.y &&
        isScrolling.value
      ) {
        // Scrolled Down
        hide_buttons.value = true;
      }
      lastContentOffset.value = event.contentOffset.y;
    },
    onBeginDrag: () => {
      isScrolling.value = true;
    },
    onEndDrag: () => {
      isScrolling.value = false;
    },
  });

  useEffect(() => {
    hide_buttons.value = open;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const showActionButtons = () => (hide_buttons.value = false);

  return {
    scrollHandler,
    showActionButtons,
    floating_action_styles,
  };
};

